import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { NewsContent, NewsTitle } from "./styles";
import { CardContent, CardHeader, CardMedia } from "@mui/material";
import React from "react";
import HtmlRender from "../HtmlRender/HtmlRender";
import { formatarData } from "../../util/theme";
const apiUrl = process.env.PORTAL_URL || "http://localhost:7004";
export const NewsBar = ({ noticias, navegatePage }) => {
    return (_jsx(Box, Object.assign({ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: 5 }, { children: noticias.map((noticia) => {
            return (
            // <CardServicesHighlight
            //   key={index}
            //   title={botao.label}
            //   imageUrl={`https://cms.demo.xvia.com.br/assets/${botao.icon}`}
            //   onClick={botao.onClick}
            // />
            _jsxs(Card, Object.assign({ sx: { maxWidth: 345, cursor: "pointer" }, onClick: () => {
                    navegatePage(noticia);
                } }, { children: [_jsx(CardHeader, { title: _jsx(NewsTitle, { children: noticia.title }), subheader: formatarData(noticia.date_updated) }), _jsx(CardMedia, { component: "img", height: "194", image: `${apiUrl}/api/doacao-sangue/assets/${noticia.thumbnail}`, alt: "Paella dish" }), _jsx(CardContent, { children: _jsx(Typography, Object.assign({ variant: "body2", sx: { color: "text.secondary" } }, { children: _jsx(NewsContent, { children: _jsx(HtmlRender, { html: noticia.content }) }) })) })] })));
        }) })));
};
